import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { Role } from '@crm/shared';
import { useAuth } from './AuthContext';

type Props = {
  children: ReactNode;
  roles?: Role[];
};

export function ProtectedRoute({ children, roles }: Props) {
  const { state } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return (
      <div className="flex h-full items-center justify-center text-zinc-500">
        Ładowanie sesji…
      </div>
    );
  }

  if (state.status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(state.user.role)) {
    return (
      <div className="flex h-full items-center justify-center text-zinc-600">
        Brak uprawnień do tej sekcji.
      </div>
    );
  }

  return <>{children}</>;
}
